import { useEffect, useState } from "react";
import useFormStore from "../../store/formData";
// import TextInput from "../inputs/TextInput";
// import useAddressStore from "../../store/useAddressStore";
import TextAreaInput from "../TextAreaInput/TextAreaInput";

const TextAreaInputContainer = (props) => {
  const { formData, setFormData } = useFormStore();
  const [value, setValue] = useState("");
  // const { addressData } = useAddressStore();
  useEffect(() => {
    formData[props.data.id]
      ? setValue(formData[props.data.id])
      : setFormData(props.data.id, "");
  }, []);

  function selectChangeHandler(value) {
    setValue(value);
    setFormData(props.data.id, value);
  }

  // useEffect(() => {
  //   setValue(addressData?.data?.address_compact);
  // }, [addressData]);

  // useEffect(() => {
  //   setFormData(props.data.id, value);
  // }, [value]);

  return (
    <TextAreaInput
      size="md" // lg , md , sm , null
      label={props.data.name} // string , null
      value={value} // state
      disabled={false} // boolian , null
      // validation={phoneValidation} // string , null
      placeholder={"..."} // string , null
      onChange={(value) => {
        selectChangeHandler(value);
      }} // setState()
      id={props.data.id}
    />
  );
};

export default TextAreaInputContainer;
